import type { ModeFrais, NatureFrais } from '../shared'

export const NatureFraisAvecQuantite: Readonly<NatureFrais[]> = [] as const
export type NatureFraisAvecQuantite = (typeof NatureFraisAvecQuantite)[number]

export const NatureFraisAnnexe = ['AchatMateriel'] as const

export const NatureFraisPedagogique = [] as const

export const NaturesFrais: { [key in ModeFrais]: Readonly<NatureFrais[]> } = {
  Annexe: NatureFraisAnnexe,
  Pedagogique: NatureFraisPedagogique,
} as const

export const HelpFraisPedagogique: { [key in NatureFrais]?: string } = {} as const

export const HelpFraisAnnexe: { [key in NatureFrais]?: string } = {} as const
